import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = {
  key: 0,
  class: "align-left"
}
const _hoisted_3 = ["innerHTML"]

import { onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

import { months } from '@/helpers/months';
import { loadWarDatabase } from '@/helpers/infoHelpers';

import { SourcesModel, SourceStructure } from '@/models/sidebar/info.model';

import 'bootstrap/dist/css/bootstrap.min.css';

const emptyString = ' ';


export default /*@__PURE__*/_defineComponent({
  __name: 'Sources',
  setup(__props) {

// TODO: This basically exists in SourceTooltip.vue ☻
const { t } = useI18n();
const store = useStore();

const sourceIds = ref<string[]>([]);
const state = reactive<SourceStructure>({
  dbSources: [],
  dbEvents: [],
  sources: [],
  markers: t('sources.markers'),
});

onMounted(async () => {
  await loadData();
  sourceIds.value = state.dbEvents.map((e) => e.source);

  state.dbSources.sort((a, b) => {
    const aIndex = sourceIds.value.filter((id: string) => id === a._id).length;
    const bIndex = sourceIds.value.filter((id: string) => id === b._id).length;
    return bIndex - aIndex;
  });
});

const loadData = async () => {
  // TODO: database may be passed down from a parent component instead
  const db = await loadWarDatabase(store.state.war);
  if (db) {
    state.dbSources = db.sources;
    state.dbEvents = db.events;
  }
};

// TODO: Check if I can put this in `` quotes
const italic = (content: string | string[]) => {
  return '<i>' + content + '</i>';
};

// TODO: Similar function exists in Date.vue
const formatMonth = (date: string): string => {
  const day = date.substring(8, 2);
  const monthIndex = Number(date.substring(5, 7)) - 1;
  const year = date.substring(0, 4);

  return `${day} ${months[monthIndex]} ${year}`;
};

const isEmpty = (source: string): boolean => {
  if (source === emptyString) {
    return true;
  }
  return false;
};

const sanitize = (value: string | string[]): string => {
  const clean = (v: string) => v.includes('/') ? v.replace(/\//g, ' ') : v;

  if (Array.isArray(value)) {
    return value.map(clean).join(', ');
  }
  else {
    return clean(value);
  }
};

const createTitle = (currentSource: SourcesModel) => {
  const fullSource = state.dbSources.find((source) => source._id === currentSource._id);
  if (!fullSource) {
    return '';
  }

  const types = {
    website: `<b>“${sanitize(fullSource.title)}”</b> ${sanitize(fullSource.author)}${isEmpty(sanitize(fullSource.author)) ? '' : ','} ${sanitize(fullSource.publisher)}${isEmpty(sanitize(fullSource.publisher)) ? '' : ','} ${formatMonth(fullSource.accessDate)}, <a target="_blank" href="${fullSource.url}">${fullSource.url}</a>`,
    newspapers: `<b>“${sanitize(fullSource.title)}”</b>${isEmpty(sanitize(fullSource.title)) ? '' : '.'} ${italic(sanitize(fullSource.publisher))}${isEmpty(sanitize(fullSource.publisher)) ? '' : ','} ${fullSource.publishDate.substring(0, 4)}.`,
    book: `${sanitize(fullSource.author)}${isEmpty(sanitize(fullSource.author)) ? '' : '.'} <b>“${sanitize(fullSource.title)}”</b> ${italic(sanitize(fullSource.publisher))}${isEmpty(sanitize(fullSource.publisher)) ? '' : ','} ${fullSource.publishDate.substring(0, 4)}.`,
    journal: `${sanitize(fullSource.author)}${isEmpty(sanitize(fullSource.author)) ? '' : '.'} <b>“${sanitize(fullSource.title)}”</b> ${italic(sanitize(fullSource.publisher))}${isEmpty(sanitize(fullSource.publisher)) ? '' : ','} ${fullSource.publishDate.substring(0, 4)}.`,
  };
  return types[fullSource.type];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container mt ml mr", { 'dark-mode': _unref(store).state.dark }])
  }, [
    (state.sources)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", {
            style: {"font-family":"'Bebas Neue', cursive","font-size":"50px"},
            class: _normalizeClass([ _ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar' ? 'text-right' : 'text-left' ])
          }, _toDisplayString(_unref(t)('sources.sourcesUsed')), 3),
          (!state.dbSources.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(t)('sources.loading')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.dbSources, (source, idx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: idx,
                  innerHTML: createTitle(source),
                  class: _normalizeClass(["word-break", [ _ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar' ? 'align-right' : 'align-left' ]])
                }, null, 10, _hoisted_3))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})